import { render, staticRenderFns } from "./StoricoAcquistiPage.vue?vue&type=template&id=49979768&"
import script from "./StoricoAcquistiPage.vue?vue&type=script&lang=js&"
export * from "./StoricoAcquistiPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports